const acfModules = [
    {
        selector: '[data-comparison-table=container]',
        path: { filename: 'comparisonTable' },
    },
    {
        selector: '[data-featurenav=nav]',
        path: { filename: 'featuresAnchorMenu' },
    },
    {
        selector: '[data-module-filter-by]',
        path: { filename: 'filterByBar' },
    },
    {
        selector: '[data-master-slider=container]',
        path: { filename: 'masterSlider/masterSlider' },
        args: { slidesPerView: { large: 3, medium: 2, small: 1 } },
    },
    {
        selector: '[data-master-slider=videos-container]',
        path: { filename: 'masterSlider/masterSlider' },
        args: { slidesPerView: { large: 3, medium: 2, small: 1 }, spaceBetween: 67 },
    },
    {
        selector:
            '[data-master-slider=guides-container], [data-master-slider=whitepapers-container]',
        path: { filename: 'masterSlider/masterSlider' },
        args: { slidesPerView: { large: 3, medium: 2, small: 1 }, spaceBetween: 67 },
    },
    {
        selector: '[data-image-slider=container]',
        path: { filename: 'imageSlider/imageSlider' },
    },
    {
        selector: '[data-module-bts=""]',
        path: { filename: 'businessTypeSelectionModule' },
    },
    {
        selector: '[data-marketo-form=""]',
        path: { filename: 'marketoForm' },
    },
    {
        selector: '[data-module-content-width=half]',
        path: { filename: 'halfWidthAlternator' },
    },
    {
        selector: '[data-animate-logo-horizontal-module]',
        path: { filename: 'logoHorizontal' },
    },
];

export { acfModules };
